import { memo } from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import { getCloudfrontUrl } from "../utils/mediaHelper";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";

const NewsDetails = memo(({ singleNews, className = "" }) => {
  return (
    <section
      className={`self-stretch flex flex-col items-start justify-start py-[40px] lg:py-[60px] px-6 sm:px-6 lg:px-20 box-border gap-10 text-5xl text-text-primary max-w-[1600px] mx-auto  ${className}`}
    >
      {/* <h2 className="m-0 relative capitalize text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
        {singleNews?.title}
      </h2> */}
      <div
        className="text-[16px] leading-[150%] m-0 rich-text"
        dangerouslySetInnerHTML={{
          __html: addDofollowToAnchors(singleNews?.description) || "",
        }}
      />
      {singleNews?.newspaper?.map((news, index) => {
        return (
          <div
            key={index}
            className={`w-full box-border flex flex-col md:flex-row items-center justify-between gap-6 max-w-full bg-[#F5F5F5] p-4 rounded-[16px] cursor-pointer hover:text-red-500`}
            onClick={() => window.open(news?.link, "_blank")}
          >
            <h3 className="m-0 w-full text-[24px] leading-[140%] font-medium capitalize">
              {news?.title}
            </h3>
            {news?.image && (
              <Image
                className="w-full md:w-auto rounded-[16px] object-contain"
                loading="lazy"
                width={420}
                height={100}
                alt={news?.title}
                src={getCloudfrontUrl(news?.image) || "/blog-posts@3x.png"}
              />
            )}
          </div>
        );
      })}
    </section>
  );
});

NewsDetails.propTypes = {
  className: PropTypes.string,
};

export default NewsDetails;
